import Image from "next/image";
import {
  CardContainerGallery,
  Description,
  ImageContainerGallery,
} from "./styles";
import { imageLoader } from "@/lib/sanity/client";
import { useState } from "react";

export type GalleryProps = {
  variant: "gallery";
  image?: {
    asset?: Record<string, any>;
  };
  description?: string;
};

const GalleryProps: React.FC<GalleryProps> = (props) => {
  const { description, image } = props;
  const [isLoaded, setIsLoaded] = useState(false);

  const getPaddingTop = () => {
    const width = image?.asset?.metadata?.dimensions?.width;
    const height = image?.asset?.metadata?.dimensions?.height;

    if (width && height) {
      const padding = (height * 100) / width;
      return Number(padding.toFixed(2));
    } else {
      return 61; // default ?
    }
  };
  return (
    <CardContainerGallery>
      <ImageContainerGallery $paddingTop={getPaddingTop()} $isLoaded={isLoaded}>
        {image && image?.asset && image.asset?.url && (
          <Image
            sizes="(max-width: 768px) 75vw, 40vw"
            src={image.asset?.url}
            layout="fill"
            objectFit="cover"
            loader={imageLoader}
            onLoadingComplete={() => setIsLoaded(true)}
            alt="" // TODO: can we have a value for this?
          />
        )}
      </ImageContainerGallery>
      {description && <Description>{description}</Description>}
    </CardContainerGallery>
  );
};
export default GalleryProps;
